
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const RESET_MESSAGE = 'RESET_MESSAGE';

/* use the state type SUCCESS_MESSAGE   */
/* use the state type  ERROR_MESSAGE  */
/* use the state type   RESET_MESSAGE 



*/
